import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";

export const Footer = ({ content }) => (
  <footer className="border-t border-white/10 bg-[#08080a] py-12">
    <div className="mx-auto flex max-w-[1500px] flex-col items-start justify-between gap-8 px-5 sm:px-10 lg:flex-row lg:items-center">
      <img src={LOGO_URL} alt="TURBOLUX AUTOSERVISS" className="h-10 w-auto object-contain" />
      <div className="font-mono-t text-[10px] uppercase tracking-[0.22em] text-slate-600">
        © {new Date().getFullYear()} TURBOLUX AUTOSERVISS · {content.address}
      </div>
      <div className="flex items-center gap-6">
        <a href="#pakalpojumi" className="link-underline font-mono-t text-[10px] uppercase tracking-[0.22em] text-slate-400">
          Pakalpojumi
        </a>
        <a href="#galerija" className="link-underline font-mono-t text-[10px] uppercase tracking-[0.22em] text-slate-400">
          Galerija
        </a>
        <Link
          to="/admin/login"
          data-testid="footer-admin-link"
          className="link-underline font-mono-t text-[10px] uppercase tracking-[0.22em] text-rose-500"
        >
          Admin
        </Link>
      </div>
    </div>
  </footer>
);
